<template>
	<b-tooltip
		:active="active"
		:dashed="!!active"
		:label="tooltip"
		:size="size"
		:type="type"
		:position="position"
		multilined
	>
		<dc-icon v-if="icon" :icon="icon" :library="library" />
		{{ label }}
	</b-tooltip>
</template>

<script>
export default {
	name: "Tooltip",
	props: {
		tip: {
			type: String,
			default: null
		},
		label: {
			type: String,
			default: null
		},
		icon: {
			type: String,
			default: () => "check"
		},
		library: {
			type: String,
			default: () => "fal"
		},
		size: {
			type: String,
			default: () => null
		},
		type: {
			type: String,
			default: () => "is-dark"
		},
		position: {
			type: String,
			default: () => "is-bottom"
		}
	},
	data() {
		return {};
	},
	computed: {
		active() {
			return !!this.tip;
		},
		tooltip() {
			return this.tip;
		}
	}
};
</script>

<style scoped>
.icon {
	/* margin-right: 0.3em; */
}
</style>
